import { Navigate } from 'react-router-dom';
import type { JSX } from 'react';
import { authClient } from '@/lib/auth-client';
import { PageLoader } from '@/components/common/PageLoader';
import { useAuthStore } from '@/stores';

export function ProtectedRoute({ children }: { children: JSX.Element }) {
  const { data: session, isPending } = authClient.useSession();
  const sessionUserId = useAuthStore(s => s.sessionUserId);
  const syncSessionUser = useAuthStore(s => s.syncSessionUser);

  // Wait for Better Auth to resolve the session
  if (isPending) {
    return <PageLoader />;
  }

  // Not authenticated → login
  if (!session?.user) {
    return <Navigate to="/login" replace />;
  }

  // Authenticated but email not verified → verification page
  if (!session.user.emailVerified) {
    return <Navigate to="/verify-email" state={{ email: session.user.email }} replace />;
  }

  // If the session user differs from the stored user, reset onboarding
  // flags synchronously and stay on the loader for one frame so children
  // never render with stale values.
  if (session.user.id !== sessionUserId) {
    syncSessionUser(session.user.id);
    return <PageLoader />;
  }

  return children;
}
